import { Row, Col, Button } from 'react-bootstrap';
import { PaymentCard } from 'components/gifts-table';
import mockupCheckout from 'assets/img/mockup_checkout.png';
import styles from './styles.module.scss';
import { useEffect, useState } from 'react';

export default function StepTwo({ handleSubmit }) {
  const handleClickPayNow = () => {
    handleSubmit();
  };

  const [statusRedirectCaja, setStatusRedirectCaja] = useState(0);

  useEffect(() => {
    setStatusRedirectCaja(window.localStorage.getItem('statusRedirectCaja'));
  });

  console.log('En two statusRedirectCaja: ', statusRedirectCaja);
  return (
    <>
      {
        statusRedirectCaja >= 1 && (
          statusRedirectCaja === '200' ? (
            <Row>
            <Col style={{ color: 'green', margin: '50px'  }}>
              <h1> </h1>
            </Col>
            </Row>
          ) : (
            <Row>
            <Col style={{ background: '#e4002b', color: '#fff', padding: '10px', borderRadius: '10px' }}>
              <h1>No se puede continuar la compra, favor de revisar con el festejado la direccion del evento. </h1>
            </Col>
            </Row>
          )
        )
      }
    </>
  );
}
